module.exports = __webpack_public_path__ + "img/inhouse.6bf0d586.svg";